import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ParentContainer from "../components/ParentContainer/ParentContainer";
import CheckoutHome from "../views/CheckoutHome/CheckoutHome";

export default function AppRoutes() {
  return (
    <Router>
      <ParentContainer>
        <Switch>
          <Route exact path="/">
            <CheckoutHome />
          </Route>
          <Route path="*">
            <CheckoutHome />
          </Route>
        </Switch>
      </ParentContainer>
    </Router>
  );
}
